import api from '@/apis/di/accountAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';
import commonFn from '@/commons/commonFunction';

// Combo grid Tài khoản nợ, có
export const useAccountComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  /**
   * customData: extend, callBackFn
   * NXCHIEN 15.07.2022
   */
  const onAccountComboboxLoadData = (payload, row, column, custom) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns =
      'account_id,account_number,account_name,parent_id,account_category_code,is_parent,is_detail_by_budget_source,is_detail_by_budget_chapter,is_detail_by_budget_kind_item,is_detail_by_budget_item,is_detail_by_budget_sub_item,is_detail_by_method_distribute,is_detail_by_accounting_object,is_detail_by_activity,is_detail_by_project,is_detail_by_task,is_detail_by_supply,is_detail_by_inventory_item,is_detail_by_fixed_asset,is_detail_by_fund,is_detail_by_bank_account,is_detail_by_project_activity,is_detail_by_investor,is_detail_by_contract';
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy tất cả dữ liệu combo
  // nthien4 15.07.2022
  const onAccountComboboxLoadAllData = (payload, row, column, customData) => {
    payload.sort = 'account_number';
    payload.columns =
      'account_id,account_number,account_name,parent_id,account_category_code,is_parent,is_detail_by_budget_source,is_detail_by_budget_chapter,is_detail_by_budget_kind_item,is_detail_by_budget_item,is_detail_by_budget_sub_item,is_detail_by_method_distribute,is_detail_by_accounting_object,is_detail_by_activity,is_detail_by_project,is_detail_by_task,is_detail_by_supply,is_detail_by_inventory_item,is_detail_by_fixed_asset,is_detail_by_fund,is_detail_by_bank_account,is_detail_by_project_activity,is_detail_by_investor,is_detail_by_contract';
    payload.take = 3000;
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const accountComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountComboboxLoadData,
  };

  // Tài khoản nợ có của grid hạch toán đồng thời
  /**
   * customData: extend, callBackFn
   * NXCHIEN 15.07.2022
   */
  const onAccountComboboxParalellLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let orsIsParent = [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
      {
        Field: 'account_number',
        Value: '0',
        Operator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const accountComboParalellConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    quickSearch: 'RemoteQuickSearchPopup',
    quickSearchParam: {
      titleSearch: 'tài khoản',
      payload: {
        sort: 'account_number',
        filter: [
          {
            Field: 'inactive',
            Value: false,
            Ors: [{ Field: 'inactive', Operator: proxy.$ms.constant.FilterOperator.Null }],
          },
          {
            Field: 'is_parent',
            Value: false,
            Ors: [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }],
          },
          {
            Field: 'account_number',
            Value: '0',
            Operator: proxy.$ms.constant.FilterOperator.StartsWith,
          },
        ],
      },
      module: 'account',
      idField: 'account_number',
    },
    dropdownWidth: 600,
    comboboxLoadData: onAccountComboboxParalellLoadData,
  };

  /**
   * Tài khoản con
   * @author nnnam - 20/8/2022
   */
  const onChildAccountLoadData = (payload, row, column, custom, requireAccounts) => {
    let accNum = commonFn.buildOrOpera(
      requireAccounts || [''],
      'account_number',
      proxy.$ms.constant.FilterOperator.StartsWith
    );
    let ors = [{ Field: 'inactive', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let orsIsParent = [{ Field: 'is_parent', Operator: proxy.$ms.constant.FilterOperator.Null }];
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'is_parent', Value: false, Ors: orsIsParent },
      accNum,
    ];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const accountComboChildConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onChildAccountLoadData,
  };

  return {
    accountComboConfig,
    onAccountComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    accountComboParalellConfig,
    onAccountComboboxParalellLoadData,
    onAccountComboboxLoadAllData,
    onChildAccountLoadData,
    accountComboChildConfig,
  };
};
